import { render, staticRenderFns } from "./PreviewReferral.vue?vue&type=template&id=2336f9a2&scoped=true&"
import script from "./PreviewReferral.vue?vue&type=script&lang=ts&"
export * from "./PreviewReferral.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewReferral.vue?vue&type=style&index=0&id=2336f9a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336f9a2",
  null
  
)

export default component.exports